export { default } from './get-device-info.web';